import { memo } from "react"

import { BaseTopBar } from "../TopBars/BaseTopBar"

export const ProcedureInitiativesViewTopBar = memo(() => {
	return <BaseTopBar />
})
ProcedureInitiativesViewTopBar.displayName = "ProcedureInitiativesViewTopBar"
